import { z } from 'zod';
export const sequenceSimulateSchema = z.object({
    lead_id: z.string().uuid(),
    assumed_tags: z.array(z.string().min(1)).max(20).optional(),
    assumed_status: z.string().min(1).max(64).optional(),
});
export const campaignSimulatePreviewSchema = z.object({
    project_id: z.string().uuid(),
    sequence_id: z.string().uuid(),
    lead_id: z.string().uuid(),
    assumed_tags: z.array(z.string().min(1)).max(20).optional(),
    assumed_status: z.string().min(1).max(64).optional(),
});
export const campaignSeedSendSchema = z.object({
    lead_id: z.string().uuid(),
    test_emails: z.array(z.string().email()).min(1).max(5),
    step_order: z.number().int().min(0).max(19).default(0),
    variant_id: z.string().uuid().optional(),
});
//# sourceMappingURL=campaignPreview.js.map